import { Component } from '@angular/core';

@Component({
  selector: 'sign-in-banner',
  templateUrl: './sign-in-banner.component.html',
  styleUrls: ['./sign-in-banner.component.scss']
})
export class SignInBannerComponent {
}
